import store from "./store";
import { notificationActions } from "./slices/notification";

export const triggerNotification = (errorMessage) => {
  store.dispatch(notificationActions.toggleNotification(errorMessage));
};
